// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-R4f","col":"styles_col__3qF7A"};